module.exports = __webpack_public_path__ + "static/allotd-3ea5a1505fee299430e79c3a3fb7391b.png";